import { FileUpload as FileUploadIcon } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Button, DialogActions, DialogContent, Typography } from "@mui/material";
import { useState } from "react";
import FileUpload from "react-material-file-upload";

const EmergencyImportDialogFileUploadStepContent = ({ onNext, onPrevious }) => {
    const [files, setFiles] = useState([]);

    const handleNextButtonClick = () => {
        if (files.length > 0) {
            onNext({ files });
        }
    };

    const handlePreviousButtonClick = () => {
        onPrevious();
    };

    return (
        <>
            <DialogContent sx={{ pt: 3 }}>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Laden Sie die Notfall-Export-Datei hoch, die von der Helper-App erstellt wurde:
                </Typography>
                <FileUpload
                    value={files}
                    onChange={setFiles}
                    accept=".txt"
                    maxFiles={1}
                    maxSize={10485760}
                    title="Datei hier ablegen oder klicken zum Auswählen"
                    buttonText="Datei auswählen"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handlePreviousButtonClick}>Zurück</Button>
                <LoadingButton
                    onClick={handleNextButtonClick}
                    variant="contained"
                    disabled={files.length === 0}
                    startIcon={<FileUploadIcon />}
                >
                    Weiter
                </LoadingButton>
            </DialogActions>
        </>
    );
};

export { EmergencyImportDialogFileUploadStepContent };